export class seo {
  es = {
    inicio: {
      t: "Pasajes en bus baratos → Chilepasajes.cl",
      k: "pasajes bus santiago,pasajes a santiago,pasajes bus a la serena,comprar pasajes bus,pasajes bus puerto montt santiago,pasajes altas cumbres,buses altas cumbres santiago,pasajes bus santiago la serena,pasajes bus la serena santiago,pasajes bus santiago concepcion, paginas para comprar pasajes en bus,pasajes, bus, chile, comprar pasajes chile, Pasajes en bus, chilepasajes.cl, pasajes baratos, pasajes cikbus, pasajes pullman tur",
      d: "Compra Pasajes de Bus Baratos para todo Chile en Chilepasajes.cl ✓Compara precios de Turbus, Pullman Bus, EME Bus y más ✓Compra tus Pasajes ahora",
      og_d_1: "Encuentra pasajes de bus baratos en",
      og_d_2: "Compara y compra pasajes al mejor precio de Turbus, Pullman Bus, Condor Bus y mucho más.",
      og_t: "| Pasajes en Turbus, Pulman Tur y más"
    },
    inicio_transfer: {
      t: "Transfer baratos → Chilepasajes.cl",
      k: "transfer aeropuertos,traslado aeropuerto,traslados a aeropuertos,transporte al aeropuerto,transfer al aeropuerto,chilepasajes.cl,traslados economicos,transfer santiago,traslados a aeropuertos santiago ",
      d: "Transfer, traslados hacia y desde el aeropuerto para tu próximo viaje",
      og_d_1: "Encuentra transfer desde aeropuertos y terminales",
      og_d_2: "reservar transfer economicos.",
      og_t: "| Transfer en santiago"
    },
    buscador: {
      t: "Pasajes Baratos en ",
      k_1: "Pasajes en bus ",
      k_2: " pasajes baratos a ",
      k_3: " viajes a ",
      k_4: " pasajes en bus de ",
      k_5: " pasajes desde ",
      d_1: "Compra tus pasajes en bus baratos de ",
      d_2: " a ",
      d_3: " y compara precios, horarios y servicios de ",
      d_4: " y Ahorra hasta un 50% ✅ MIRA →",
      og_d_1: "Encuentra pasajes de bus baratos",
      og_d_2: "en",
      og_d_3: "Compara y compra pasajes al mejor precio de Turbus, Pullman Bus, Condor Bus y mucho más.",
      og_t: "Pasajes en Turbus, Pulman Bus y más"
    },
     buscador_transfer: {
      t: "Transfer Baratos en ",
      k_1: "Traslados a ",
      k_2: " transfer baratos a ",
      k_3: " traslados a aeropuerto",
      k_4: " traslados a santiago de ",
      k_5: " transfer desde ",
      d_1: " Reserva de transfer desde ",
      d_2: " a ",
      d_3: " y compara precios, horarios  ",
      d_4: " y Ahorra en tu compra.",
      og_d_1: "Encuentra transfer al mejor precio.",
      og_d_2: "en",
      og_d_3: "Compara y reserva transfer.",
      og_t: "transfer a "
    },
    servicio_cliente: {
      t: "Chilepasajes.cl → Ayuda al cliente",
      k: "Servicio al cliente, ayuda al cliente Chilepasajes.cl, preguntas frecuentes Chilepasajes.",
      d: "Servicio al cliente, ayuda al cliente Chilepasajes.cl, preguntas frecuentes Chilepasajes.",
      og_d: "Servicio al cliente, ayuda al cliente Chilepasajes.cl, preguntas frecuentes Chilepasajes.",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    },
    anular_boletos: {
      t: "Chilepasajes.cl → Gestión boletos",
      k: "Gestión boletos Chilepasajes.cl, cupones gestión boletos, anular compra, cancelar boleto.",
      d: "Gestión boletos Chilepasajes.cl, cupones gestión boletos, anular compra, cancelar boleto, canjear puntos, obtener cupón Chilepasajes.cl",
      og_d: "Gestión boletos Chilepasajes.cl, cupones gestión boletos.",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    },
    mapa_sitio: {
      t: "Chilepasajes.cl → Mapa del sitio",
      k: "Mapa del sitio, operadores de buses, terminales, ciudades, destinos.",
      d: "Mapa del sitio chilepasajes.cl, buscar operadores de buses, buscar terminales, buscar ciudades, buscar destinos en chilepasajes.cl.",
      og_d: "Mapa del sitio, operadores de buses, terminales, ciudades, destinos.",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    },
    terminos_condiciones: {
      t: "Chilepasajes.cl → Terminos y condiciones",
      k: "Terminos y condiciones Chilepasajes.cl.",
      d: "Terminos y condiciones Chilepasajes.cl, terminos y condiciones para viajar en buses Chilepasajes.cl, estos son los terminos y condiciones viaje buses.",
      og_d: "Terminos y condiciones Chilepasajes.cl",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    },
    politicas_privacidad: {
      t: "Chilepasajes.cl → Politicas de privacidad",
      k: "Politicas de privacidad en Chilepasajes.cl.",
      d: "Politicas de privacidad en Chilepasajes.cl, politicas de privacidad Chilepasajes.cl, Chilepasajes.cl politicas de privacidad Chilepasajes.cl.",
      og_d: "Politicas de privacidad en Chilepasajes.cl.",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    },
    politicas_cookies: {
      t: "Chilepasajes.cl → Politicas de cookies",
      k: "Politicas de cookies en Chilepasajes.cl.",
      d: "Politicas de cookies en Chilepasajes.cl, politicas de cookies Chilepasajes.cl, Chilepasajes.cl politicas de cookies Chilepasajes.cl.",
      og_d: "Politicas de cookies en Chilepasajes.cl.",
      og_t: "| Pasajes en Turbus, Pulman Bus y más"
    }
  }

  en = {
    inicio: {
      t: "Cheap bus tickets → Chilepasajes.cl",
      k: "Bus tickets, chilepasajes.cl, cheap tickets, turbus tickets, pullman bus tickets, Eme bus tickets.",
      d: "Buy Cheap Bus Tickets for all of Chile at Chilepasajes.cl ✓ Compare prices of Turbus, Pullman Bus, EME Bus and more ✓Buy your Tickets now.",
      og_d_1: "Find cheap bus tickets in",
      og_d_2: "Compare and buy tickets at the best price for Turbus, Pullman Bus, Condor Bus and much more.",
      og_t: "| Tickets in Turbus, Pulman Bus and more."
    },
    inicio_transfer: {
      t: "Cheap transfer → Chilepasajes.cl",
      k: "transfer, airport transfers, chilepasajes.cl, economic transfers, transfer santiago, airport transfers santiago, transfers to airports santiago.",
      d: "Transfer, transfers to and from the airport for your next trip.",
      og_d_1: "Find airport and terminal transfer.s",
      og_d_2: "economic transfers.",
      og_t: "| Transfer in santiago."
    },
    buscador: {
      t: "cheap tickets in ",
      k_1: " bus tickets ",
      k_2: " cheap tickets to ",
      k_3: " Trips to ",
      k_4: " bus tickets from ",
      k_5: " tickets from ",
      d_1: " Buy your cheap bus tickets from ",
      d_2: " to ",
      d_3: " and compare prices, schedules and services of ",
      d_4: " and Save up to 50% ✅ LOOK → ",
      og_d_1: "Find cheap bus tickets",
      og_d_2: "in",
      og_d_3: "Compare and buy tickets at the best price for Turbus, Pullman Bus, Condor Bus and much more.",
      og_t: "Tickets in Turbus, Pulman Bus and more"
    },
    buscador_transfer: {
      t: "cheap Transfers in ",
      k_1: " transfers to",
      k_2: " cheap transfer to ",
      k_3: " airport and terminal transfers ",
      k_4: " transfers to santiago ",
      k_5: " transfer from ",
      d_1: " Book your transfers ",
      d_2: " to ",
      d_3: " and compare prices, schedules of ",
      d_4: " and Save up to 50% ✅ LOOK → ",
      og_d_1: "Find transfer at the best price",
      og_d_2: "in",
      og_d_3: "Compare and buy transfer.",
      og_t: "transfer to"
    },
    servicio_cliente: {
      t: "Chilepasajes.cl → Customer Help",
      k: "Customer service, customer help Chilepasajes.cl, frequently asked questions Chilepasajes.",
      d: "Customer service, customer help Chilepasajes.cl, frequently asked questions Chilepasajes.",
      og_d: "Customer service, customer help Chilepasajes.cl, frequently asked questions Chilepasajes.",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    },
    anular_boletos: {
      t: "Chilepasajes.cl → Cancel tickets",
      k: "Cancel tickets Chilepasajes.cl, coupons cancel tickets, cancel purchase, cancel ticket.",
      d: "Cancel tickets Chilepasajes.cl, coupons cancel tickets, cancel purchase, cancel ticket, redeem points, get coupon Chilepasajes.cl",
      og_d: "Cancel tickets Chilepasajes.cl, coupons cancel tickets.",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    },
    mapa_sitio: {
      t: "Chilepasajes.cl → Sitemap",
      k: "Site map, bus operators, terminals, cities, destinations.",
      d: "Chilepasajes.cl site map, search for bus operators, search for terminals, search for cities, search for destinations in chilepasajes.cl",
      og_d: "Site map, bus operators, terminals, cities, destinations.",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    },
    terminos_condiciones: {
      t: "Chilepasajes.cl → Terms and conditions",
      k: "Terms and conditions Chilepasajes.cl",
      d: "Terms and conditions Chilepasajes.cl, terms and conditions to travel on buses Chilepasajes.cl, these are the terms and conditions for bus travel.",
      og_d: "Terms and conditions Chilepasajes.cl",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    },
    politicas_privacidad: {
      t: "Chilepasajes.cl → Privacy Policy",
      k: "Privacy policies in Chilepasajes.cl",
      d: "Privacy policies in Chilepasajes.cl, Chilepasajes.cl privacy policies, Chilepasajes.cl Chilepasajes.cl privacy policies.",
      og_d: "Privacy policies in Chilepasajes.cl",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    },
    politicas_cookies: {
      t: "Chilepasajes.cl → Cookies policy",
      k: "Cookie policies in Chilepasajes.cl",
      d: "Cookie policies in Chilepasajes.cl, cookie policies Chilepasajes.cl, Chilepasajes.cl cookie policies Chilepasajes.cl",
      og_d: "Cookie policies in Chilepasajes.cl",
      og_t: "| Tickets in Turbus, Pulman Bus and more"
    }
  }
}
